import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/geren.png'
import _imports_1 from '@/assets/icon/qiye.png'
import _imports_2 from '@/assets/icon/weirenzheng.png'


const _withScopeId = n => (_pushScopeId("data-v-9848df8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "username" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  key: 2,
  src: _imports_1,
  alt: ""
}
const _hoisted_7 = {
  key: 3,
  src: _imports_2,
  alt: ""
}
const _hoisted_8 = { class: "vip" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "novip"
}
const _hoisted_11 = { class: "company" }
const _hoisted_12 = { class: "company-name" }
const _hoisted_13 = { class: "list" }
const _hoisted_14 = { class: "list-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "作品", -1))
const _hoisted_16 = { class: "list-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关注", -1))
const _hoisted_18 = { class: "list-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "粉丝", -1))
const _hoisted_20 = {
  key: 0,
  class: "myself"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.getImgUrl(_ctx.userinfot.portrait),
      alt: "",
      class: "photo"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.userinfot.username), 1),
      (_ctx.userinfot.username == null || _ctx.userinfot.username == '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.userinfot.mobile), 1))
        : _createCommentVNode("", true),
      (
          _ctx.getInformation.data.company_id == null &&
          _ctx.getInformation.data.identification == 3
        )
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.getInformation.data.company_id != null)
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : _createCommentVNode("", true),
      (
          _ctx.getInformation.data.company_id == null &&
          _ctx.getInformation.data.identification != 3
        )
        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.vipinfo.userimgurl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.vipinfo.userimgurl,
            alt: ""
          }, null, 8, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.isVip)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: "vip-title",
            style: _normalizeStyle({ color: _ctx.vipinfo.usercolor })
          }, _toDisplayString(_ctx.userinfot.vipInfo.vipTitle), 5))
        : _createCommentVNode("", true),
      (!_ctx.isVip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "开通会员全场商品八折优惠"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getInformation.data.company
            ? _ctx.getInformation.data.company
            : _ctx.getInformation.data.username), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", null, _toDisplayString(_ctx.userFansInfor.data.works ? _ctx.userFansInfor.data.works : 0), 1),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", null, _toDisplayString(_ctx.userFansInfor.data.follows ? _ctx.userFansInfor.data.follows : 0), 1),
        _hoisted_17
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", null, _toDisplayString(_ctx.userFansInfor.data.fans ? _ctx.userFansInfor.data.fans : 0), 1),
        _hoisted_19
      ])
    ]),
    (_ctx.getInformation.data.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_ctx.getInformation.data.company_id == null)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "myself-title",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goUser && _ctx.goUser(...args)))
              }, " 个人主页 "))
            : _createCommentVNode("", true),
          (_ctx.getInformation.data.company_id != null)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "myself-title",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goUser && _ctx.goUser(...args)))
              }, " 企业主页 "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}